import { useState } from 'react';
import { BusinessesService } from 'service/businesses.service';

export const useSaveToMyContacts = () => {
  const [loading, setLoading] = useState(false);

  const postContact = async (id: string, zoominfoPersonId: string) => {
    try {
      setLoading(true);
      await BusinessesService.saveToMyContacts(id, { zoominfoPersonId });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const deleteContact = async (id: string) => {
    try {
      setLoading(true);
      // await BusinessesService.saveToMyContacts(id);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return {
    deleteContact,
    postContact,
    loading,
  };
};
